<div class="page-container productSearch-container container">
  <app-utility-toolbar />
  <h1 class="header col-12">Annuity Rate Leaderboard</h1>
  <mat-form-field appearance="outline" class="col-12 col-md-6 col-lg-3">
    <mat-label>Annuity Type</mat-label>
    <mat-select
      #annuityTypeCtrl="ngModel"
      name="annuityType"
      required
      [(ngModel)]="annuityType"
      (ngModelChange)="onFormValueChange()"
    >
      <mat-option value="ALL"> All </mat-option>
      <mat-option value="FIA"> FIA </mat-option>
      <mat-option value="RILA"> RILA </mat-option>
      <mat-option value="FA"> FA </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="card-info">
    @if (pdfData) {
      <kendo-pdfviewer
        style="height: 85vh"
        [data]="pdfData"
        [tools]="pdfViewerTools"
      />
    }
  </div>
  <ngx-loading [show]="loading" />
</div>
